export const validarCPF = (cpf, pais) => {
    if (pais == 'pt-BR') {
        if (!cpf) return `CPF inválido!`

        cpf = cpf.replace(/[^\d]+/g, '')

        if (cpf.length !== 11) return `CPF deve ter 11 dígitos!`

        if (/^(.)\1+$/.test(cpf)) return 'CPF inválido!'

        let soma = 0
        for (let i = 0; i < 9; i++) {
            soma += parseInt(cpf.charAt(i)) * (10 - i)
        }
        let resto = 11 - (soma % 11)
        let digito1 = (resto === 10 || resto === 11) ? 0 : resto

        soma = 0
        for (let i = 0; i < 10; i++) {
            soma += parseInt(cpf.charAt(i)) * (11 - i)
        }
        resto = 11 - (soma % 11)
        let digito2 = (resto === 10 || resto === 11) ? 0 : resto

        if (digito1 !== parseInt(cpf.charAt(9)) || digito2 !== parseInt(cpf.charAt(10))) {
            return 'CPF inválido!'
        }
    } else if (pais == 'es-CL') {
        // valida rut com ou sem mascara
        if (!cpf) return 'RUT inválido!'

        const rut = cpf.trim().toUpperCase()

        if (!/^(\d{1,2}\.?\d{3}\.?\d{3}-?[0-9K])$/.test(rut)) return 'RUT inválido!'

        const clean = rut.replace(/[.-]/g, '')

        const body = clean.slice(0, -1)
        const dv = clean.slice(-1)

        let sum = 0;
        let multiplier = 2

        for (let i = body.length - 1; i >= 0; i--) {
            sum += Number(body[i]) * multiplier
            multiplier = multiplier === 7 ? 2 : multiplier + 1
        }

        const expected = 11 - (sum % 11)

        const dvCalc = expected === 11 ? '0' : expected === 10 ? 'K' : String(expected)

        if (dvCalc !== dv) return 'RUT inválido!'
    }

    return 'ok'
}
